/*
 * Copyright (c) 2019. AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

import * as React from "react";
import { Route, RouteComponentProps } from "react-router-dom";
import DocumentPage from "components/base/DocumentPage/DocumentPage";

export default function() {
  return [
    <Route key="HomePage" path="/" component={DocumentPage} exact />,
    <Route
      key="DocumentPage"
      path="/:localizedPolicyId"
      component={(props: RouteComponentProps<{ localizedPolicyId: string }>) => (
        <DocumentPage localizedPolicyId={props.match.params.localizedPolicyId} />
      )}
      exact
    />,
  ];
}
